// Iter68 — Drivers admin converted to card grid.
import React, { useEffect, useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import { DELIVERY } from "@/constants/testIds";

const LATM_LOGO = "https://customer-assets.emergentagent.com/job_dispensary-app/artifacts/87lszunl_LATM-logo.png";
function dollars(c) { return c == null ? "—" : `$${((c||0)/100).toFixed(2)}`; }

export default function AdminDeliveryDrivers() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const reload = async () => {
    try { const { data } = await api.get("/admin/delivery/profiles"); setRows(data); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  useEffect(() => { reload(); }, []);

  const setStatus = async (id, status) => { await api.put(`/admin/delivery/profiles/${id}/status`, { status }); await reload(); };
  const setBg = async (id, background_check) => { await api.put(`/admin/delivery/profiles/${id}/background-check`, { background_check }); await reload(); };

  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Delivery admin</div>
        <h1 className="headline-xl">Drivers</h1>
        <p className="text-sm text-lifted-dim mt-1">{rows.length} driver{rows.length === 1 ? "" : "s"}</p>
      </header>
      {err && <div className="text-rose-300 text-sm">{err}</div>}

      <div data-testid={DELIVERY.driversList} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {rows.map((d) => (
          <div
            key={d.id}
            data-testid={DELIVERY.driverRow(d.id)}
            className="glass-panel p-4 flex flex-col gap-3 border border-transparent hover:border-lifted-green/30 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="relative w-14 h-14 rounded-full overflow-hidden bg-black/40 border border-white/10 shrink-0">
                <img
                  src={d.avatar_url || LATM_LOGO}
                  alt={d.name}
                  onError={(e) => { e.currentTarget.src = LATM_LOGO; }}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-base font-semibold text-lifted-text truncate">{d.name}</div>
                <div className="text-xs text-lifted-dim truncate">{d.email}</div>
                <div className="text-[10px] text-lifted-mute uppercase tracking-wider mt-1">
                  {d.availability || "—"} · {(d.zones_served || []).join(", ") || "no zones"}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 text-center">
              <div>
                <div className="font-anton text-xl text-lifted-green leading-none">{d.stats?.completed_deliveries ?? 0}</div>
                <div className="text-[9px] text-lifted-mute uppercase tracking-wider mt-1">Deliveries</div>
              </div>
              <div>
                <div className="font-anton text-xl text-lifted-text leading-none">{dollars(d.stats?.lifetime_earnings_cents)}</div>
                <div className="text-[9px] text-lifted-mute uppercase tracking-wider mt-1">Lifetime</div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 text-xs">
              <label className="flex flex-col gap-1">
                <span className="text-[9px] uppercase tracking-wider text-lifted-mute">Bg check</span>
                <select
                  className="bg-lifted-surface border border-white/10 rounded-md px-2 py-1 text-xs"
                  value={d.background_check}
                  onChange={(e) => setBg(d.id, e.target.value)}
                >
                  <option value="pending">pending</option>
                  <option value="passed">passed</option>
                  <option value="failed">failed</option>
                </select>
              </label>
              <label className="flex flex-col gap-1">
                <span className="text-[9px] uppercase tracking-wider text-lifted-mute">Status</span>
                <select
                  className="bg-lifted-surface border border-white/10 rounded-md px-2 py-1 text-xs"
                  value={d.status}
                  onChange={(e) => setStatus(d.id, e.target.value)}
                >
                  <option value="active">active</option>
                  <option value="suspended">suspended</option>
                  <option value="offboarded">offboarded</option>
                </select>
              </label>
            </div>
          </div>
        ))}
        {rows.length === 0 && (
          <div className="col-span-full text-center text-lifted-mute py-10">
            No drivers yet. Grant the driver role from /admin/users or approve a driver application.
          </div>
        )}
      </div>
    </div>
  );
}
